export default "__VITE_ASSET__CbbF4d2Z__"